import * as React from 'react';

interface SGDropdownBackgroundProps {
    children: any
}

export const DropdownBackground = (props: SGDropdownBackgroundProps) => (
    <div className="dropdown-box__background">{ props.children }</div>
);
